import React from 'react';
import {
  Navigate,
  useLocation,
  useParams,
  useSearchParams,
} from 'react-router-dom';

import { pageKeywords, pagePaths } from '../../../constants/Page';
import { WorkContentParams } from './WorkContent';

/**
 * 就業内容リダイレクト
 * @returns
 */
const WorkContentRedirect: React.FunctionComponent = () => {
  const params = useParams<WorkContentParams>();
  const location = useLocation();

  return (
    <Navigate
      replace
      to={`${pagePaths.WORK_CONTENT}/${params.date}/${params.usercode}/${pageKeywords.mode.VIEW}${location.search}`}
    />
  );
};

export default WorkContentRedirect;
